/**
 * Canonical asset-class sleeves — the 12 columns of the wide Rikuz.
 * Shared BE↔FE. Port of ref_sleeve_labels.py + SLEEVE_COLUMNS (parse_workbooks.py).
 */
export const SLEEVES = [
    { sleeveId: 'StocksIL', column: 'stocks_il', displayNameHe: 'מניות ישראל', sortOrder: 1 },
    { sleeveId: 'StocksForeign', column: 'stocks_foreign', displayNameHe: 'מניות חו"ל', sortOrder: 2 },
    { sleeveId: 'Commodities', column: 'commodities', displayNameHe: 'סחורות', sortOrder: 3 },
    { sleeveId: 'BondsCpiCorp', column: 'bonds_cpi_corp', displayNameHe: 'אג"ח צמוד מדד קונצרני', sortOrder: 4 },
    { sleeveId: 'BondsCpiGov', column: 'bonds_cpi_gov', displayNameHe: 'אג"ח צמוד מדד ממשלתי', sortOrder: 5 },
    { sleeveId: 'BondsForeign', column: 'bonds_foreign', displayNameHe: 'אג"ח חו"ל', sortOrder: 6 },
    { sleeveId: 'BondsNisCorp', column: 'bonds_nis_corp', displayNameHe: 'אג"ח שקלי קונצרני', sortOrder: 7 },
    { sleeveId: 'BondsNisGov', column: 'bonds_nis_gov', displayNameHe: 'אג"ח שקלי ממשלתי', sortOrder: 8 },
    { sleeveId: 'MoneyMarket', column: 'money_market', displayNameHe: 'מק"מ', sortOrder: 9 },
    { sleeveId: 'CashIls', column: 'cash_ils', displayNameHe: 'עו"ש ופח"ק', sortOrder: 10 },
    { sleeveId: 'CashFx', column: 'cash_fx', displayNameHe: 'עו"ש מט"ח', sortOrder: 11 },
    // Alternative investments (private funds, hedge funds, real assets held as a
    // fund). The team's reports carry it as its own bucket; until now it was not
    // read at all, so a portfolio holding it came out short.
    { sleeveId: 'Alternatives', column: 'alternatives', displayNameHe: 'אלטרנטיבי', sortOrder: 12 },
];
export const SLEEVE_BY_ID = Object.fromEntries(SLEEVES.map((s) => [s.sleeveId, s]));
/**
 * Team-editable label→sleeve seed (port of ref_sleeve_labels.py SEED_DATA).
 * Keys are normalize()d Hebrew labels as they appear in workbook headers.
 * Lives in the ref_sleeve_labels table at runtime; this seeds it.
 */
export const SLEEVE_LABEL_SEED = [
    { normalizedLabel: 'מניות ישראל', sleeveId: 'StocksIL' },
    { normalizedLabel: 'מניות חול', sleeveId: 'StocksForeign' },
    { normalizedLabel: 'סחורות', sleeveId: 'Commodities' },
    { normalizedLabel: 'אגח צמוד מדד קונצרני', sleeveId: 'BondsCpiCorp' },
    { normalizedLabel: 'אגח צמוד מדד ממשלתי', sleeveId: 'BondsCpiGov' },
    { normalizedLabel: 'אגח צמוד מטח', sleeveId: 'BondsForeign' },
    { normalizedLabel: 'אגח שקלי קונצרני', sleeveId: 'BondsNisCorp' },
    { normalizedLabel: 'אגח שקלי ממשלתי', sleeveId: 'BondsNisGov' },
    { normalizedLabel: 'מקמ', sleeveId: 'MoneyMarket' },
    { normalizedLabel: 'עוש ופחק', sleeveId: 'CashIls' },
    { normalizedLabel: 'עוש ופחק מטח', sleeveId: 'CashFx' },
    // Common variants new clients use
    { normalizedLabel: 'אגח ממשלתי צמוד מדד', sleeveId: 'BondsCpiGov' },
    { normalizedLabel: 'אגח ממשלתי שקלי', sleeveId: 'BondsNisGov' },
    { normalizedLabel: 'אגח קונצרני צמוד מדד', sleeveId: 'BondsCpiCorp' },
    { normalizedLabel: 'אגח קונצרני שקלי', sleeveId: 'BondsNisCorp' },
    { normalizedLabel: 'אגח קונצ מדדי', sleeveId: 'BondsCpiCorp' },
    { normalizedLabel: 'אגח קונצרני כללי', sleeveId: 'BondsNisCorp' },
    // Alternatives, as the masters spell it
    { normalizedLabel: 'אלטרנטיבי', sleeveId: 'Alternatives' },
    { normalizedLabel: 'אלטרנטיביות', sleeveId: 'Alternatives' },
    { normalizedLabel: 'אלטרנטיב', sleeveId: 'Alternatives' },
    { normalizedLabel: 'השקעות אלטרנטיביות', sleeveId: 'Alternatives' },
    { normalizedLabel: 'נכסים אלטרנטיביים', sleeveId: 'Alternatives' },
];
//# sourceMappingURL=sleeves.js.map